import type { CardUrl, FieldTypes } from 'types';

export type FieldDefinition =
  | {
      type: Exclude<FieldTypes, 'url'>;
      subType?: undefined;
      lockKey?: string;
    }
  | {
      type: 'url';
      subType: CardUrl['type'];
      lockKey?: string;
    };

export type FieldSectionDefinition = {
  heading: string;
  fields: FieldDefinition[];
};

export const FIELD_SECTIONS: FieldSectionDefinition[] = [
  {
    heading: 'Personal',
    fields: [
      { type: 'name' },
      { type: 'job_title' },
      { type: 'department' },
      { type: 'org_name' },
      { type: 'accreditations' },
      { type: 'headline' },
    ],
  },
  {
    heading: 'General',
    fields: [
      { type: 'email' },
      { type: 'phone' },
      { type: 'url', subType: 'org' },
      { type: 'url', subType: 'link' },
      { type: 'url', subType: 'calendar' },
      { type: 'address' },
    ],
  },
  {
    heading: 'Social',
    fields: [
      { type: 'url', subType: 'twitter' },
      { type: 'url', subType: 'instagram' },
      { type: 'url', subType: 'threads' },
      { type: 'url', subType: 'linkedin' },
      { type: 'url', subType: 'facebook' },
      { type: 'url', subType: 'youtube' },
      { type: 'url', subType: 'snapchat' },
      { type: 'url', subType: 'tiktok' },
      { type: 'url', subType: 'twitch' },
      { type: 'url', subType: 'yelp' },
    ],
  },
  {
    heading: 'Messaging',
    fields: [
      { type: 'url', subType: 'whatsapp' },
      { type: 'url', subType: 'signal' },
      { type: 'url', subType: 'discord' },
      { type: 'url', subType: 'skype' },
      { type: 'url', subType: 'telegram' },
    ],
  },
  {
    heading: 'Business',
    fields: [
      { type: 'url', subType: 'github' },
      { type: 'url', subType: 'calendly' },
    ],
  },
  {
    heading: 'Payment',
    fields: [
      { type: 'url', subType: 'paypal' },
      { type: 'url', subType: 'venmo' },
      { type: 'url', subType: 'cashapp' },
    ],
  },
];
